import {
  Avatar,
  Button,
  Dropdown,
  Image,
  TableColumnsType,
  Tag,
  Tooltip,
} from "antd";
import TableUi from "../../../atoms/Table";
import { useEffect, useRef, useState } from "react";
import { ClientsType } from "../ducks/types";
import { PopUp } from "../../../atoms/PopUp";
import EmptyCard from "../../../atoms/EmptyCard";
import {
  CrossIcon,
  DeleteIcon,
  NeedHelp,
  TickIcon,
} from "../../../atoms/CustomIcons";
import ConfirmDelete from "../../../atoms/ConfirmDelete";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { getCrewListing, removeCrewListData } from "../ducks/actions";
import { changeCrewStatus, deleteCrew } from "../ducks/services";
import SuccessMessage from "../../../atoms/Toasts/SuccessMessage";
import ErrorMessage from "../../../atoms/Toasts/ErrorMessage";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { getCompanyFieldsById } from "../../CompanySettings/TagsCategories/ducks/actions";
import { CaretDownOutlined, MoreOutlined } from "@ant-design/icons";
import Filters from "./Components/Filters";
import DashboardTemplate from "../../../templates/Dashboard";
import Header from "../../../atoms/Header";
import { getInitials, getValueBeforeUnderscore } from "../../../config/utils";

export default function Crews() {
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const navigate = useNavigate();
  const companyId = pathSegments[pathSegments.length - 1];
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);
  const [tableRecord, setTableRecord] = useState<ClientsType | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [archivePopUp, setArchivePopUp] = useState(false);
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [archived, isArchived] = useState(false);
  const [mineOnly, isMineOnly] = useState(false);
  const dispatch = useAppDispatch();
  const crewListData = useAppSelector(
    (state) => state?.crewsSubs?.crewListData
  );

  const tagItems = useAppSelector((state) => state?.tags?.tagData);

  useEffect(() => {
    if (companyId) {
      const payload = {
        company_id: companyId,
        module: "CREWS",
      };

      dispatch(getCompanyFieldsById(payload));
    }
  }, [dispatch, companyId]);

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string;
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/edit-crews/${tableRecord?.id}/${companyId}`);
          }}
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            tableRecord?.status === "active"
              ? setArchivePopUp(true)
              : archiveFunction();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
          icon={
            <Image
              src={`/images/table/${
                tableRecord?.status === "active" ? "archive" : "activate"
              }-icon.svg`}
              preview={false}
            />
          }
        >
          {tableRecord?.status === "active" ? "Archive" : "Activate"}
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteModalOpen(true);
          }}
          className="delete-hover"
          icon={<DeleteIcon />}
        >
          Delete
        </Button>
      ),
    },
  ];

  const statusItems = [
    {
      key: "active",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            archiveFunction();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#00A07D", borderRadius: "2px" }}
          />
          Activate
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "archived",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            tableRecord?.status === "active"
              ? setArchivePopUp(true)
              : archiveFunction();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#6C7478", borderRadius: "2px" }}
          />
          Archived
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
  ];

  console.log("tableRecord?.status", tableRecord?.status);

  const onClickRow = () => {
    return {
      onClick: () => {
        navigate(`/crews/profile/${companyId}`);
      },
    };
  };

  const columns: TableColumnsType<ClientsType> = [
    {
      title: "Crew name",
      dataIndex: "name",
      width: 118,
      render: (text, record) =>
        text ? `${text} ${record?.last_name ?? ""}` : "-",
      fixed: "left",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
      title: (
        <Tooltip title="The person in charge of managing the crew">
          Crew leader
        </Tooltip>
      ),
      dataIndex: "crewLeader",
      width: 150,
      render: (text) =>
        text ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Avatar size={24} style={{ marginRight: 8 }}>
              {getInitials(text?.first_name, text?.last_name)}
            </Avatar>
            <div style={{ textTransform: "capitalize", display: "flex" }}>
              <span>{text?.first_name} </span>
              <span
                style={{
                  display: "inline-block",
                  maxWidth: "16px",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  marginLeft: "3px",
                }}
              >
                {text?.last_name ?? ""}
              </span>
            </div>
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: (
        <Tooltip title="The service areas the crew works in">
          Service lines
        </Tooltip>
      ),
      dataIndex: "crewServiceLines",
      width: 200,
      render: (text) =>
        text?.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {text?.map(
              (
                e: { crewServiceLine: { name: string; color: string } },
                i: number
              ) => (
                <Tag
                  key={i}
                  className={`defaultTag ${
                    e?.crewServiceLine?.color
                      ? getValueBeforeUnderscore(e?.crewServiceLine?.color)
                      : "default_tag"
                  }`}
                >
                  {e?.crewServiceLine?.name}
                </Tag>
              )
            )}
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: (
        <Tooltip title="Total number of crew members, including the Crew Leader">
          Crew size
        </Tooltip>
      ),
      dataIndex: "crew_size",
      width: 102,
      render: (text) => text ?? "-",
      align: "right",
    },
    {
      title: (
        <Tooltip title="List of team members in the crew">Crew members</Tooltip>
      ),
      dataIndex: "crewMembers",
      width: 260,
      render: (text) =>
        text?.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {text
              ?.slice(0, 2)
              .map(
                (item: {
                  crewMember: { first_name: string; last_name: string };
                  id: string;
                }) => {
                  return (
                    <Tag
                      key={item?.id}
                      style={{
                        textTransform: "capitalize",
                        backgroundColor: "#fff",
                        borderColor: "#EFF2F3",
                      }}
                      // className={tagDetails?.color}
                    >
                      {`${item?.crewMember?.first_name ?? ""} ${
                        item?.crewMember?.last_name ?? ""
                      }`}
                    </Tag>
                  );
                }
              )}

            {text?.length > 2 && (
              <Tooltip
                title={text
                  ?.slice(2)
                  ?.map(
                    (item: {
                      crewMember: { first_name: string; last_name: string };
                      id: string;
                    }) => {
                      return `${item?.crewMember?.first_name ?? ""} ${
                        item?.crewMember?.last_name ?? ""
                      }`;
                    }
                  )
                  ?.join(", ")}
              >
                <Tag
                  style={{
                    background: "#fff",
                    color: "#151718",
                    borderColor: "#EFF2F3",
                    cursor: "pointer",
                  }}
                >
                  +{text?.length - 2}
                </Tag>
              </Tooltip>
            )}
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: "Properties",
      dataIndex: "contract_status",
      width: 109,
      render: (text) =>
        text?.length > 0 ? <Tag className="yellow_tag"> {text} </Tag> : "-",
      align: "right",
    },
    {
      title: (
        <Tooltip title="Number of ongoing contracts assigned to the crew">
          Active contracts
        </Tooltip>
      ),
      dataIndex: "potential_deals",
      width: 147,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: "Categories",
      dataIndex: "category_ids",
      width: 147,

      render: (text: string[]) =>
        text?.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {text?.slice(0, 1).map((item: string) => {
              const tagDetails: { name: string } = tagItems?.data?.find(
                (tag: { id: string }) => tag?.id === item
              ) || { name: "" };

              return (
                <Tag
                  key={item}
                  style={{ textTransform: "capitalize" }}
                  className="white_tag"
                >
                  {tagDetails?.name}
                </Tag>
              );
            })}

            {text?.length > 1 && (
              <Tooltip
                title={text
                  ?.slice(1)
                  ?.map((itemId: string) => {
                    const tagDetails: { name: string } = tagItems?.data?.find(
                      (tag: { id: string }) => tag?.id === itemId
                    ) || { name: "" };
                    return tagDetails?.name;
                  })
                  ?.join(", ")}
              >
                <Tag
                  style={{
                    background: "#fff",
                    color: "#151718",
                    borderColor: "#EFF2F3",
                    cursor: "pointer",
                  }}
                >
                  +{text?.length - 1}
                </Tag>
              </Tooltip>
            )}
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: (
        <Tooltip title="Percentage of productive time compared to total available time this year">
          Productivity (YTD), %
        </Tooltip>
      ),
      dataIndex: "main_contracts",
      width: 200,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: (
        <Tooltip title="Percentage of time crew was actively working on billable services this year">
          Utilization rate (YTD), %
        </Tooltip>
      ),
      dataIndex: "billing_contracts",
      width: 200,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: (
        <Tooltip title="Total revenue generated from labor year-to-date">
          Labor revenue (YTD), $
        </Tooltip>
      ),
      dataIndex: "labor",
      width: 200,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: (
        <Tooltip title="Gross margin from labor work as a percentage of revenue this year">
          Labor GM (YTD), %
        </Tooltip>
      ),
      dataIndex: "active_contracts_sum",
      width: 200,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: (
        <Tooltip title="Average revenue earned per labor hour this year">
          Revenue per labor hr (YTD), $
        </Tooltip>
      ),
      dataIndex: "accounts_receivable",
      width: 224,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: (
        <Tooltip title="Gross margin generated per labor hour this year">
          GM per labor hr (YTD), %
        </Tooltip>
      ),
      dataIndex: "earned_revenue_ytd",
      width: 200,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: (
        <Tooltip title="Percentage of productive time over the past 12 months">
          Productivity (R12M), %
        </Tooltip>
      ),
      dataIndex: "gross_margin",
      width: 200,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: (
        <Tooltip title="Percentage of time spent on billable work in the last 12 months">
          Utilization rate (R12M), %
        </Tooltip>
      ),
      dataIndex: "gross_profit",
      width: 200,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: (
        <Tooltip title="Revenue from labor over the last 12 months">
          Labor revenue (R12M), $
        </Tooltip>
      ),
      dataIndex: "wind_ratio",
      width: 200,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: (
        <Tooltip title="Gross margin from labor as a percentage of revenue over the last 12 months">
          Labor GM (R12M), %
        </Tooltip>
      ),
      dataIndex: "earned_revenue_r12m",
      width: 200,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: (
        <Tooltip title="Average revenue earned per labor hour in the past 12 months">
          Revenue per labor hr (R12M), $
        </Tooltip>
      ),
      dataIndex: "gross_margin_r12m",
      width: 224,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: (
        <Tooltip title="Gross margin generated per labor hour in the past 12 months">
          GM per labor hr (R12M), %
        </Tooltip>
      ),
      dataIndex: "gross_profit_r12m",
      width: 200,
      render: (text) => (text ? text : "-"),
      align: "right",
    },
    {
      title: "Crew status",
      dataIndex: "status",
      width: 147,
      render: (text, record) => (
        <Dropdown
          menu={{
            items: statusItems,
            selectable: true,
            selectedKeys: [text],
          }}
          trigger={["click"]}
          overlayClassName="status_dropdown_overlay"
        >
          <Button
            onClick={(e) => {
              setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            className={`status_dropdown ${text}_status`}
            ref={dropdownRef}
            style={{ textTransform: "capitalize" }}
          >
            {text}{" "}
            <div className="icon_arrow">
              <CaretDownOutlined />
            </div>
          </Button>
        </Dropdown>
      ),
    },
    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{
            items:
              record?.status === "active"
                ? items
                : items.filter(
                    (item) => item?.key !== "1" && item?.key !== "1"
                  ),
          }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              console.log("text", record);
              setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      ),
    },
  ];

  const fetchUserListing = (status: string) => {
    const payload = {
      company_id: companyId,
      offset: 0,
      limit: 10,
      status: status ?? "active",
      mine_only: mineOnly,
    };
    dispatch(getCrewListing(payload));
  };

  const deleteFunction = () => {
    setLoading(true);
    deleteCrew(
      selectedRowKeys?.length > 0 ? selectedRowKeys : [tableRecord?.id || ""]
    )
      .then(() => {
        setLoading(false);
        setIsDeleteModalOpen(false);
        setSelectedRowKeys([]);
        fetchUserListing(tableRecord?.status ?? "active");
        SuccessMessage("Crew deleted");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const deleteClientPopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          selectedRowKeys?.length > 0 ? (
            <>
              Are you sure you want to delete selected crews?
              <br />
              This action cannot be undone.
            </>
          ) : (
            <>
              Are you sure you want to delete <b>{tableRecord?.name}</b>?<br />
              <br />
              This action cannot be undone.
            </>
          )
        }
        btnText={
          selectedRowKeys?.length > 0
            ? `Delete ${
                selectedRowKeys?.length === 1
                  ? selectedRowKeys?.length + " crew"
                  : selectedRowKeys?.length + " crews"
              }`
            : "Delete crew"
        }
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const archiveFunction = () => {
    setLoading(true);
    const payload = {
      status: tableRecord?.status === "active" ? "archived" : "active",
    };
    changeCrewStatus(tableRecord?.id as string, payload)
      .then(() => {
        setLoading(false);
        setArchivePopUp(false);
        fetchUserListing(tableRecord?.status ?? "active");
        SuccessMessage(
          `Crew ${tableRecord?.status === "active" ? "archived" : "activated"}`
        );
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const confirmArchivedPopUp = {
    visibility: archivePopUp,
    content: (
      <ConfirmDelete
        title=""
        isArchivePopup={true}
        onClose={() => setArchivePopUp(false)}
        heading={tableRecord?.status === "active" ? "Archive" : "Activate"}
        paragraph={
          <>
            Are you sure you want to{" "}
            {tableRecord?.status === "active" ? "archive" : "activate"}{" "}
            <b>{tableRecord?.name}</b>? <br /> <br />
            {tableRecord?.status === "active" && (
              <>This crew won’t be available for use.</>
            )}
          </>
        }
        btnText={`${
          tableRecord?.status === "active" ? "Archive" : "Activate"
        } crew`}
        btnApi={archiveFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setArchivePopUp(false),
  };

  useEffect(() => {
    dispatch(removeCrewListData());
  }, [dispatch]);

  useEffect(() => {
    if (companyId) {
      const payload = {
        status: filters?.status ?? "active",
        offset: pagination > 1 ? limit * (pagination - 1) : pagination - 1,
        limit: limit,
        company_id: companyId,
        type: filters?.type ?? undefined,
        search_text: filters?.search_text ?? undefined,
        mine_only: mineOnly,
      };
      dispatch(getCrewListing(payload));
      console.log("payload", payload);
    }
  }, [dispatch, filters, pagination, limit, companyId, mineOnly]);

  console.log("clientListData", crewListData?.data);

  // const onClickRow = () => {
  //   return {
  //     onClick: () => {
  //       navigate(`/crews/profile/${companyId}`);
  //     },
  //   };
  // };

  return (
    <DashboardTemplate loading={loading || crewListData?.loader}>
      <Header
        title="Crews & Subs"
        description="View and manage your crews and subcontractors."
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
      />
      <TableUi<ClientsType>
        columns={columns}
        data={{
          count: crewListData?.count,
          data: crewListData?.data || [],
        }}
        filters={
          <Filters
            setFilters={setFilters}
            filters={filters}
            archived={archived}
            isArchived={isArchived}
            companyId={companyId}
            mineOnly={mineOnly}
            isMineOnly={isMineOnly}
          />
        }
        pageSize={limit}
        setPageSize={setLimit}
        setCurrentPage={setPagination}
        currentPage={pagination}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        createButtonText="Create crew"
        createButtonLink={`/add-crews/${companyId}`}
        onClickRow={onClickRow}
      />
      {!crewListData?.loader && crewListData?.data?.length === 0 && (
        <div className="empty_wrap">
          <EmptyCard
            imageHeight={220}
            title={
              archived
                ? "There are no archived crews"
                : filters?.search_text
                ? "No results match the filter or search criteria"
                : `There are no ${filters?.status ?? "active"} crews`
            }
            description={
              archived
                ? "We believe in our absolute success and hope to never have an archived crews here."
                : filters?.search_text
                ? "Try adjusting the filters and search."
                : ""
            }
            image={
              archived
                ? "/images/empty-icons/no-archived.svg"
                : "/images/empty-icons/no-active.svg"
            }
          />
        </div>
      )}

      {selectedRowKeys?.length !== 0 ? (
        <div className="selection_bar">
          <div className="selected_count">
            <Button
              icon={<CrossIcon style={{ color: "white" }} />}
              className="only_icon"
              type="text"
              onClick={() => setSelectedRowKeys([])}
            />
            {selectedRowKeys.length}{" "}
            {`${selectedRowKeys.length === 1 ? "crew" : "crews"}`} selected
          </div>
          <div className="selection_buttons">
            <Button
              type="text"
              icon={<DeleteIcon />}
              onClick={() => {
                setIsDeleteModalOpen(true);
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      ) : null}

      <PopUp {...deleteClientPopUp} />
      <PopUp {...confirmArchivedPopUp} />
    </DashboardTemplate>
  );
}
